// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"95493490","135":"69da4c5f","325":"e1d3d28a","373":"34278651","434":"00356ce7","469":"42699fc1","611":"61c85cd0","651":"d2beaa07","656":"e7716839","865":"41edf527","885":"09eef4f2","940":"a6b31db5"}[chunkId] + ".chunk.js";
};